import { useEffect, useRef, useState } from "react";
// import { Button, ButtonGroup, Card, Dropdown } from "react-bootstrap";
import { Chart, registerables } from 'chart.js';
import moment from "moment";
import { Button, ButtonGroup, Card, Dropdown } from "react-bootstrap";
import { hexToRGB, UCWords } from "../../../components/resources";
import { EventBigProducts } from "../../../assets/constants";
// import autocolors from 'chartjs-plugin-autocolors';
// import moment from "moment";
// import { arrayAverage } from "../../../components/resources";

Chart.register(...registerables);


/**
 * 
 * @param {Object} props
 * @param {{product: string, payment_month: number, payment_year: number, amount: number}[]}  props.incomes
 * @returns 
 */
const WorkDoneGraph = ({ incomes = {} }) => {


    const [years, setYears] = useState([]);
    const [data, setData] = useState([]);

    const [labels, setLabels] = useState([]);
    const [chart_data, setChartData] = useState([]);

    const [selected, setSelected] = useState();



    useEffect(() => {

        let _years = [], _data = {};

        incomes.forEach(inc => {
            let y = parseInt(inc.event_year),
                m = parseInt(inc.event_month),
                p = inc.product,
                a = parseFloat(inc.amount);

            if (EventBigProducts.indexOf(p) === -1) p = "other";

            if (_years.indexOf(y) === -1) _years.push(y);

            if (!(y in _data)) _data[y] = {};

            if (!(p in _data[y])) _data[y][p] = {};

            if (!(m in _data[y][p])) _data[y][p][m] = [];

            _data[y][p][m].push(a);

        })

        setYears(_years.sort((a, b) => (b - a)));
        setData(_data);
        setSelected(Math.max(..._years));


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(incomes)])

    useEffect(() => {

        const _data = data[selected],
            max_month = parseInt(moment().format("YYYY")) === selected ? parseInt(moment().format("M")) : 12,
            dataset = [];


        for (let category in _data) {

            let set = [], color = "#" + Math.floor(Math.random() * 16777215).toString(16);

            for (let m = 1; m < (max_month + 1); m++) {

                if (m in _data[category]) {
                    set.push(_data[category][m].reduce((p, c) => p + c, 0))
                } else {
                    set.push(0);
                }

            }

            dataset.push({
                label: UCWords(category.replace(/-/g, " ")),
                data: set,
                fill: false,
                borderColor: color,
                backgroundColor: hexToRGB(color, 0.4)
            })
        }

        setChartData(dataset);
        setLabels(Array(max_month).fill(1).map((k, i) => moment(`${i + 1}`, "M").format("MMM")))



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected, JSON.stringify(data)])

    const onDPChange = key => setSelected(key);


    return (
        <Card className="my-2 my-sm-5">
            <Card.Header className="d-flex align-items-center justify-content-between py-3">
                <h4 className='my-0'>Value of Work Done</h4>
                <span>
                    <Dropdown as={ButtonGroup} className="me-3" align="end">
                        <Button variant="outline-secondary">
                            {selected}
                        </Button>
                        <Dropdown.Toggle split variant="secondary" />
                        <Dropdown.Menu>
                            {years.map((b) =>
                                <Dropdown.Item
                                    onClick={() => onDPChange(b)}
                                    eventKey={b} key={b}
                                >
                                    {b}
                                </Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                    {/* <span className="font-weight-normal">25</span>
                    <span className="text-success ms-3">
                        <i className="fas fa-arrow-up small" /> 5.00%
                    </span> */}
                </span>
            </Card.Header>
            <Card.Body>
                <div style={{ maxHeight: '600px' }}>
                    <Graph data={chart_data} labels={labels} />
                </div>
            </Card.Body>
        </Card>
    )
}


const Graph = ({ data, labels }) => {

    const canvasElement = useRef();

    useEffect(() => {
        const chart = new Chart(canvasElement.current, {
            type: 'line',
            data: {
                labels,
                datasets: data

                // [{
                //     label: 'Fee Notes',
                //     data: data.feenotes,
                //     backgroundColor: 'rgba(255, 99, 132, 0.2)',
                //     borderColor: 'rgba(255, 99, 132, 1)',
                //     borderWidth: 1,
                //     yAxisID: 'yAxis1',
                //     categoryPercentage: 0.95
                // },
                // {
                //     label: 'No Titles',
                //     type: "line",
                //     data: data.no_titles,
                //     backgroundColor: 'rgba(54, 162, 235, 0.2)',
                //     borderColor: 'rgba(54, 162, 235, 1)',
                //     borderWidth: 1,
                //     yAxisID: 'yAxis2',
                //     categoryPercentage: 0.95
                // },
                // {
                //     label: 'Turn Around Time',
                //     type: "line",
                //     data: data.turnaround_times,
                //     backgroundColor: 'rgba(255, 206, 86, 0.2)',
                //     borderColor: 'rgba(255, 206, 86, 1)',
                //     borderWidth: 1,
                //     yAxisID: 'yAxis3',
                //     categoryPercentage: 0.95
                // }]
            },
            options: {
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: "Amount (UGX)"
                        }
                    }
                },
                elements: {
                    point: {
                        radius: 1
                    },
                    line: {
                        tension: 0.3,
                        borderWidth: 1.5
                    }
                }
            }
        });

        return () => chart.destroy();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(data)])

    return <canvas ref={canvasElement} width="100%" />
}


export default WorkDoneGraph;